<template>
  <div class="container">
    <div><headerNav /></div>
    <div class="page-content">
    
      <router-view v-on:footer="footer"/>
   
    </div>
   <div v-if="footer_show"><footerNav /></div>
  </div>
</template>

<script>
import headerNav from "@/components/com/black/headerNav.vue";
import footerNav from "@/components/com/black/footerNav.vue";
import "@/style/venue.scss";
export default {
  components: {
    headerNav,
    footerNav
  },
      data(){
          return{
            footer_show:true
          }
      },
    methods:{
      //是否显示底部
      footer:function (bool) {
          this.footer_show = bool;
      }
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/com/black/layout.vue